import React from 'react';
import { useLocation } from 'react-router-dom';
import { CONTEXT_TO_DOC_ID, getHelpContextForRoute } from '@/data/help-context-map';
import { getInlineTipForContext } from '@/data/help-inline-tips';
import HelpDot from './HelpDot';

/** Route-aware inline help tip for the current screen. */
const ScreenHelpDot: React.FC = () => {
  const location = useLocation();
  const context = getHelpContextForRoute(location.pathname, location.search);
  if (!context || context === 'help' || context === 'changelog') {
    return null;
  }

  const tip = getInlineTipForContext(context);
  if (!tip) {
    return null;
  }

  const docId = CONTEXT_TO_DOC_ID[context];

  return <HelpDot title={tip.title} body={tip.body} storageKey={tip.storageKey} docId={docId} />;
};

export default ScreenHelpDot;
